import { render, staticRenderFns } from "./BrandSafety.vue?vue&type=template&id=6710968c&scoped=true&"
import script from "./BrandSafety.vue?vue&type=script&lang=js&"
export * from "./BrandSafety.vue?vue&type=script&lang=js&"
import style0 from "./BrandSafety.vue?vue&type=style&index=0&id=6710968c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6710968c",
  null
  
)

export default component.exports